var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarcodeScan = function SvgBarcodeScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M3.5 12.086H21M8 8.5v7M11 8.5v7M14 8.5v7M17 8.5v7M3.862 15.569v2.103a1 1 0 0 0 1 1h2.724M3.862 8.604V6.5a1 1 0 0 1 1-1h2.724M20.759 15.569v2.103a1 1 0 0 1-1 1h-2.724M20.759 8.604V6.5a1 1 0 0 0-1-1h-2.724"
  })));
};
export default SvgBarcodeScan;